var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1122 1122",
    style: {
      enableBackground: "new 0 0 1122 1122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#72716F;}\n\t.st1{fill:#F2CB30;}\n\t.st2{fill:#EAB531;}\n\t.st3{fill:#58595A;}\n\t.st4{fill:#F7DB5E;}\n\t.st5{fill:#3E3D40;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Object"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_52_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_53_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_56_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M650.7,413.5l4.7,17l42.1-11.6l-4.7-17c-23.2-83.9-110.4-133.3-194.3-110.1 C414.6,314.9,365.2,402.1,388.4,486l38.5,139.1l42.1-11.6l-38.5-139.1c-16.8-60.7,18.9-123.8,79.7-140.6 S633.9,352.7,650.7,413.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_54_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    className: "st1",
    d: "M785.7,819.1c0,9.3-7.6,16.9-16.9,16.9H353.2c-9.3,0-16.9-7.6-16.9-16.9V549 c0-9.3,7.6-16.9,16.9-16.9h415.6c9.3,0,16.9,7.6,16.9,16.9V819.1z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M785.7,819.1V653.6C648.8,769.5,451.4,813,339.5,829c3.1,4.2,8,7,13.7,7h415.6 C778.2,836,785.7,828.4,785.7,819.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M598.1,638.3c0-20.5-16.6-37.1-37.1-37.1s-37.1,16.6-37.1,37.1c0,12.2,5.9,23,15.1,29.8l-11.8,84h67.8 l-11.8-84C592.2,661.3,598.1,650.5,598.1,638.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M352.7,564.1v58.2c1.5-24.7,13.4-78.4,87.7-78.4H373C361.8,543.9,352.7,553,352.7,564.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M527.1,752.1c0,0,50.3-14.2,56-84l11.8,84H527.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.6a9c4a95debe10349e4a44e8f18ba98c.svg";
export { ForwardRef as ReactComponent };